module.exports = __webpack_public_path__ + "75535b403746296a6ba662b4e43ce198.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/images/ch_grid_1.png
// module id = 111
// module chunks = 1